export const languages = [
  { code: 'en', name: 'English' },
  { code: 'ru', name: 'Русский' },
  { code: 'es', name: 'Español' },
  { code: 'fr', name: 'Français' },
  { code: 'de', name: 'Deutsch' },
  { code: 'it', name: 'Italiano' },
  { code: 'pt', name: 'Português' },
  { code: 'zh', name: '中文' },
  { code: 'ja', name: '日本語' },
  { code: 'ko', name: '한국어' },
];

export const translations = {
  en: {
    about: "About",
    title: "Dildo Works — 3D Dildo Generator",
    intro: "Dildo Works is a free, browser-based parametric 3D dildo generator for designers, sculptors, educators, and 3D printing enthusiasts. Adjust anatomy and material with real-time controls and export production-ready meshes in STL or OBJ format — no software installation required.",
    featuresTitle: "Features",
    features: [
      "13 parametric controls: length, shaft girth, glans size, corona definition, curvature, taper, ridges, veins, ball size, base flare, color, roughness, and subsurface scattering",
      "Real-time WebGL rendering with custom GLSL shaders for realistic silicone, skin, and rubber materials",
      "Export to STL (for 3D printing) or OBJ (for use in Blender, ZBrush, Maya, etc.)",
      "Built-in presets: Realistic, Classic, Large, Slim, Fantasy",
      "Random generator for exploring shape combinations",
      "Share links to save and send your specific configuration",
    ],
    useCasesTitle: "Use Cases",
    useCasesText: "Designed for sex toy product designers, anatomical sculptors, game prop artists, medical educators, and 3D printing hobbyists who need accurate parametric models. The generator is useful for product prototyping, educational anatomy reference, artistic exploration, and creating custom 3D printable designs.",
    howItWorksTitle: "How It Works",
    howItWorksText: "All geometry is computed procedurally in the browser using Three.js. No assets are downloaded — the mesh is generated on-the-fly using a swept-profile tube algorithm along a Bezier spine curve, with parametric displacement for ridges and vein detail. Exported files are clean meshes suitable for slicing or sculpting. For 3D printing, we recommend running exported files through a mesh repair tool (e.g. Meshmixer or PrusaSlicer) to ensure watertightness.",
    back: "← Open Generator",
    generator: "Generator",
  },
  ru: {
    about: "О проекте",
    title: "Dildo Works — 3D Генератор Дилдо",
    intro: "Dildo Works — это бесплатный браузерный параметрический 3D-генератор дилдо для дизайнеров, скульпторов, педагогов и энтузиастов 3D-печати. Настраивайте форму и материал с помощью элементов управления в реальном времени и экспортируйте готовые к производству сетки в формате STL или OBJ.",
    featuresTitle: "Особенности",
    features: [
      "13 параметрических элементов управления: длина, толщина ствола, размер головки, выраженность венчика, кривизна, сужение, рёбра, вены, размер мошонки, основание, цвет, шероховатость и подповерхностное рассеивание",
      "Рендеринг WebGL в реальном времени с пользовательскими шейдерами GLSL для силикона, кожи и резины",
      "Экспорт в STL (для 3D-печати) или OBJ (для использования в Blender, ZBrush, Maya и т.д.)",
      "Встроенные пресеты: Реалистичный, Классический, Большой, Тонкий, Фэнтези",
      "Случайный генератор для исследования комбинаций форм",
      "Ссылки для сохранения и отправки конфигурации",
    ],
    useCasesTitle: "Сценарии использования",
    useCasesText: "Создан для дизайнеров секс-игрушек, анатомических скульпторов, художников по игровому реквизиту, медицинских педагогов и любителей 3D-печати, которым нужны точные параметрические модели. Генератор полезен для прототипирования продуктов, анатомических образовательных материалов, художественных исследований и создания пользовательских 3D-печатных конструкций.",
    howItWorksTitle: "Как это работает",
    howItWorksText: "Вся геометрия вычисляется процедурно в браузере с использованием Three.js. Сетка генерируется на лету с помощью алгоритма трубки с выметаемым профилем вдоль кривой Безье, с параметрическим смещением для рёбер и вен. Для 3D-печати рекомендуем пропустить экспортированные файлы через инструмент восстановления сетки.",
    back: "← Открыть генератор",
    generator: "Генератор",
  },
  es: {
    about: "Acerca de",
    title: "Dildo Works — Generador de Dildo 3D",
    intro: "Dildo Works es un generador de dildo 3D paramétrico gratuito basado en navegador para diseñadores, escultores, educadores y entusiastas de la impresión 3D. Ajuste la forma y el material con controles en tiempo real y exporte mallas listas para producción en formato STL u OBJ.",
    featuresTitle: "Características",
    features: [
      "13 controles paramétricos: longitud, grosor del tallo, tamaño del glande, definición de la corona, curvatura, conicidad, crestas, venas, tamaño de testículos, brida de base, color, rugosidad y dispersión subsuperficial",
      "Renderizado WebGL en tiempo real con shaders GLSL personalizados para silicona, piel y goma",
      "Exportación a STL (para impresión 3D) o OBJ (para uso en Blender, ZBrush, Maya, etc.)",
      "Preajustes incorporados: Realista, Clásico, Grande, Delgado, Fantasía",
      "Generador aleatorio para explorar combinaciones de formas",
    ],
    useCasesTitle: "Casos de Uso",
    useCasesText: "Diseñado para diseñadores de juguetes eróticos, escultores anatómicos, artistas de props para videojuegos, educadores médicos y aficionados a la impresión 3D.",
    howItWorksTitle: "Cómo Funciona",
    howItWorksText: "Toda la geometría se calcula de forma procedural en el navegador usando Three.js. La malla se genera a partir de un algoritmo de tubo de perfil barrido a lo largo de una curva Bezier, con desplazamiento paramétrico para crestas y venas.",
    back: "← Abrir Generador",
    generator: "Generador",
  },
  fr: {
    about: "À propos",
    title: "Dildo Works — Générateur de Gode 3D",
    intro: "Dildo Works est un générateur de gode 3D paramétrique gratuit basé sur navigateur pour les designers, sculpteurs, éducateurs et passionnés d'impression 3D. Ajustez la forme et le matériau avec des contrôles en temps réel et exportez des maillages prêts à la production au format STL ou OBJ.",
    featuresTitle: "Caractéristiques",
    features: [
      "13 contrôles paramétriques : longueur, épaisseur de tige, taille du gland, définition de la couronne, courbure, effilement, crêtes, veines, taille des testicules, base évasée, couleur, rugosité et diffusion sous-surfacique",
      "Rendu WebGL en temps réel avec shaders GLSL personnalisés pour silicone, peau et caoutchouc",
      "Exportation vers STL (pour l'impression 3D) ou OBJ (pour Blender, ZBrush, Maya, etc.)",
      "Préréglages intégrés : Réaliste, Classique, Grand, Mince, Fantaisie",
    ],
    useCasesTitle: "Cas d'utilisation",
    useCasesText: "Conçu pour les designers de jouets érotiques, sculpteurs anatomiques, artistes de props de jeux vidéo, éducateurs médicaux et amateurs d'impression 3D.",
    howItWorksTitle: "Comment ça marche",
    howItWorksText: "Toute la géométrie est calculée de manière procédurale dans le navigateur avec Three.js. Le maillage est généré à la volée via un algorithme de tube à profil balayé le long d'une courbe de Bézier.",
    back: "← Ouvrir le Générateur",
    generator: "Générateur",
  },
  de: {
    about: "Über",
    title: "Dildo Works — 3D-Dildo-Generator",
    intro: "Dildo Works ist ein kostenloser, browserbasierter parametrischer 3D-Dildo-Generator für Designer, Bildhauer, Pädagogen und 3D-Druck-Enthusiasten. Passen Sie Form und Material mit Echtzeit-Steuerungen an und exportieren Sie produktionsreife Netze im STL- oder OBJ-Format.",
    featuresTitle: "Eigenschaften",
    features: [
      "13 parametrische Steuerungen: Länge, Schaftumfang, Eichelgröße, Kronendefiniton, Krümmung, Konizität, Rippen, Venen, Hodengröße, Basisflansch, Farbe, Rauheit und Subsurface Scattering",
      "Echtzeit-WebGL-Rendering mit benutzerdefinierten GLSL-Shadern für Silikon, Haut und Gummi",
      "Export als STL (für 3D-Druck) oder OBJ (für Blender, ZBrush, Maya usw.)",
    ],
    useCasesTitle: "Anwendungsfälle",
    useCasesText: "Entwickelt für Sex-Toy-Designer, anatomische Bildhauer, Game-Prop-Künstler, medizinische Pädagogen und 3D-Druck-Enthusiasten.",
    howItWorksTitle: "Wie es funktioniert",
    howItWorksText: "Die gesamte Geometrie wird prozedural im Browser mit Three.js berechnet, unter Verwendung eines Rohr-Sweep-Algorithmus entlang einer Bezier-Kurve.",
    back: "← Generator öffnen",
    generator: "Generator",
  },
  it: {
    about: "Informazioni",
    title: "Dildo Works — Generatore di Dildo 3D",
    intro: "Dildo Works è un generatore di dildo 3D parametrico gratuito basato su browser per designer, scultori, educatori e appassionati di stampa 3D.",
    featuresTitle: "Caratteristiche",
    features: [
      "13 controlli parametrici: lunghezza, circonferenza asta, dimensione glande, definizione corona, curvatura, rastremazione, creste, vene, dimensione testicoli, flangia base, colore, rugosità e scattering sub-superficiale",
      "Rendering WebGL in tempo reale con shader GLSL personalizzati per silicone, pelle e gomma",
      "Esportazione in STL (per stampa 3D) o OBJ (per Blender, ZBrush, Maya, ecc.)",
    ],
    useCasesTitle: "Casi d'uso",
    useCasesText: "Progettato per designer di sex toy, scultori anatomici, artisti di prop per videogiochi, educatori medici e appassionati di stampa 3D.",
    howItWorksTitle: "Come funziona",
    howItWorksText: "Tutta la geometria viene calcolata in modo procedurale nel browser usando Three.js, tramite un algoritmo di tubo con profilo swept lungo una curva di Bezier.",
    back: "← Apri Generatore",
    generator: "Generatore",
  },
  pt: {
    about: "Sobre",
    title: "Dildo Works — Gerador de Dildo 3D",
    intro: "Dildo Works é um gerador de dildo 3D paramétrico gratuito baseado em navegador para designers, escultores, educadores e entusiastas de impressão 3D.",
    featuresTitle: "Recursos",
    features: [
      "13 controles paramétricos: comprimento, circunferência do cabo, tamanho da glande, definição da coroa, curvatura, afilamento, saliências, veias, tamanho dos testículos, flange da base, cor, rugosidade e dispersão sub-superficial",
      "Renderização WebGL em tempo real com shaders GLSL personalizados para silicone, pele e borracha",
      "Exportação para STL (impressão 3D) ou OBJ (Blender, ZBrush, Maya, etc.)",
    ],
    useCasesTitle: "Casos de Uso",
    useCasesText: "Projetado para designers de brinquedos eróticos, escultores anatômicos, artistas de props para jogos, educadores médicos e amadores de impressão 3D.",
    howItWorksTitle: "Como Funciona",
    howItWorksText: "Toda a geometria é calculada de forma procedural no navegador usando Three.js, com algoritmo de tubo de perfil swept ao longo de uma curva Bezier.",
    back: "← Abrir Gerador",
    generator: "Gerador",
  },
  zh: {
    about: "关于",
    title: "Dildo Works — 3D假阳具生成器",
    intro: "Dildo Works是一个免费的、基于浏览器的参数化3D假阳具生成器，适合设计师、雕塑家、教育工作者和3D打印爱好者使用。",
    featuresTitle: "特点",
    features: [
      "13个参数控制：长度、轴径、龟头大小、冠状沟定义、弯曲度、锥度、凸脊、血管、睾丸大小、底座边缘、颜色、粗糙度和次表面散射",
      "使用自定义GLSL着色器的实时WebGL渲染，支持硅胶、皮肤和橡胶材质",
      "导出为STL（3D打印）或OBJ（Blender、ZBrush、Maya等）",
    ],
    useCasesTitle: "使用案例",
    useCasesText: "专为成人玩具产品设计师、解剖雕塑家、游戏道具艺术家、医学教育工作者和3D打印爱好者设计。",
    howItWorksTitle: "工作原理",
    howItWorksText: "所有几何体都通过Three.js在浏览器中程序化计算，使用沿贝塞尔曲线脊柱的扫掠管状算法生成网格。",
    back: "← 打开生成器",
    generator: "生成器",
  },
  ja: {
    about: "概要",
    title: "Dildo Works — 3Dディルドジェネレーター",
    intro: "Dildo Worksは、デザイナー、彫刻家、教育者、3Dプリント愛好家向けの無料ブラウザベース・パラメトリック3Dディルドジェネレーターです。",
    featuresTitle: "特徴",
    features: [
      "13個のパラメトリックコントロール：長さ、シャフト胴回り、亀頭サイズ、冠状溝の定義、曲率、テーパー、リッジ、静脈、睾丸サイズ、ベースフレア、色、粗さ、サブサーフェススキャタリング",
      "カスタムGLSLシェーダーによるリアルタイムWebGLレンダリング（シリコン、肌、ゴム素材対応）",
      "STL（3Dプリント）またはOBJ（Blender、ZBrush、Mayaなど）へのエクスポート",
    ],
    useCasesTitle: "ユースケース",
    useCasesText: "アダルトトイデザイナー、解剖彫刻家、ゲームプロップアーティスト、医療教育者、3Dプリント愛好家向けに設計されています。",
    howItWorksTitle: "仕組み",
    howItWorksText: "すべてのジオメトリはThree.jsを使用してブラウザ内で手続き的に計算され、ベジェ曲線スパインに沿ったスウェプトチューブアルゴリズムを使用しています。",
    back: "← ジェネレーターを開く",
    generator: "ジェネレーター",
  },
  ko: {
    about: "소개",
    title: "Dildo Works — 3D 딜도 생성기",
    intro: "Dildo Works는 디자이너, 조각가, 교육자, 3D 프린팅 애호가를 위한 무료 브라우저 기반 파라메트릭 3D 딜도 생성기입니다.",
    featuresTitle: "특징",
    features: [
      "13가지 파라메트릭 제어: 길이, 샤프트 둘레, 귀두 크기, 코로나 정의, 곡률, 테이퍼, 능선, 정맥, 고환 크기, 베이스 플레어, 색상, 거칠기, 서브서피스 스캐터링",
      "실리콘, 피부, 고무 재질을 위한 커스텀 GLSL 셰이더로 실시간 WebGL 렌더링",
      "STL(3D 프린팅) 또는 OBJ(Blender, ZBrush, Maya 등)로 내보내기",
    ],
    useCasesTitle: "사용 사례",
    useCasesText: "성인 완구 제품 디자이너, 해부학 조각가, 게임 프롭 아티스트, 의료 교육자, 3D 프린팅 애호가를 위해 설계되었습니다.",
    howItWorksTitle: "작동 방식",
    howItWorksText: "모든 형상은 Three.js를 사용하여 브라우저에서 절차적으로 계산되며, 베지어 곡선 스파인을 따라 스웹트 튜브 알고리즘을 사용합니다.",
    back: "← 생성기 열기",
    generator: "생성기",
  },
};
